module.exports = __webpack_public_path__ + "static/media/md-volume-high.e6445464.svg";